import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavParams, ToastController, ViewController } from 'ionic-angular';
import { Account } from '../../../../model/account';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { Observable } from 'rxjs';
import { JudgeService } from '../../../../services/judge.service';
import { DataService } from '../../../../services/data';
import { Judge, JudgeCategory } from 'model/judge';

@Component({
    selector: 'staff-judges-config',
    templateUrl: 'judge-popup.html'
})
export class JudgePopup implements OnInit {
    judgeForm: FormGroup;
    categoryForm: FormGroup;
    searchChangeObservable;
    loadingData: boolean;
    userResults: Account[] = [];
    selectedUser: Account;
    @Input() viewMode: 'judge' | 'categories';
    @Input() rodeoEvent: RodeoEvent;
    @Input() rodeoId: number;
    @Input() penalty: boolean;

    constructor(
        private toast: ToastController,
        private viewCtrl: ViewController,
        private judgeService: JudgeService,
        private fb: FormBuilder,
        private navParams: NavParams,
        private dataService: DataService
    ) { }

    ngOnInit() {
        this.rodeoEvent = this.navParams.get('rodeoEvent');
        this.rodeoId = this.navParams.get('rodeoId');
        if (!this.viewMode) {
            this.viewMode = this.navParams.get('viewMode');
        }

        if (!this.penalty) {
            this.penalty = this.navParams.get('penalty');
        }
        
        if (this.viewMode == 'judge') {
            const judge = this.navParams.get('data');
            if (judge) {
                this.selectedUser = judge.account;
            }
            this.initJudgeForm(judge);
        } else {
            const category = this.navParams.get('data');
            this.initCategoriesForm(category);
        };
    }

    initJudgeForm(judge: Judge = null) {
        this.judgeForm = this.fb.group({
            search: this.fb.group({
                firstName: '',
                lastName: ''
            }),
            judge: this.fb.group({
                id: [judge ? judge.id : 0],
                accountId: [judge ? judge.accountId : null, [Validators.required]],
                rodeoId: this.rodeoId,
                rodeoEventId: this.rodeoEvent ? this.rodeoEvent.id : null
            })
        });

        (this.judgeForm.get('search') as FormGroup).get('firstName').valueChanges.subscribe(value => this.onSearchChange('firstName' + value));
        (this.judgeForm.get('search') as FormGroup).get('lastName').valueChanges.subscribe(value => this.onSearchChange('lastName' + value));

    }

    initCategoriesForm(category: JudgeCategory = null) {
        this.categoryForm = this.fb.group({
            id: [category ? category.id : 0],
            category: [category ? category.category : '', [Validators.required, Validators.maxLength(200)]],
            rodeoId: [category ? category.rodeoId : this.rodeoId],
            rodeoEventId: [category ? category.rodeoEventId : this.rodeoEvent ? this.rodeoEvent.id : null],
            min: [category ? category.min : 0, [Validators.required, Validators.min(-1000), Validators.max(1000)]],
            max: [category ? category.max : 0, [Validators.required, Validators.min(-1000), Validators.max(1000)]],
            allowDecimal: [category ? category.allowDecimal : false],
            penalty: [category ? category.penalty : false]
        });
    }

    selectUser(user: Account) {  
     this.selectedUser = user;
     this.judgeForm.get('judge').get('accountId').patchValue(user.id);
     this.judgeForm.get('search').reset();
    }

    clearUser() {
        this.selectedUser = null;
        this.judgeForm.get('judge').get('accountId').patchValue(null);
    }

    save() {
        const form = this.viewMode == 'judge' ? this.judgeForm.get('judge') : this.categoryForm;

        if (this.penalty) {
            form.value.penalty = true;
            form.value.min = form.value.max;
        }

        if (form.valid) {
            (this.viewMode == 'judge' ? this.judgeService.saveJudge(form.value) : this.judgeService.saveJudgeCategory(form.value))
            .then(judge => {
                this.toast.create({
                    message: `Saved ${this.viewMode}!`,
                    duration: 3000,
                    position: 'bottom',
                    cssClass: 'toast-success'
                }).present();
                this.viewCtrl.dismiss(judge);
            })
            .catch(err => {
                this.toast.create({
                    message: err.message || `Could not save ${this.viewMode}.`,
                    duration: 3000,
                    position: 'bottom',
                    cssClass: 'toast-error'
                }).present();
            });
        }
    }

    close() {
        this.viewCtrl.dismiss();
    }

    private onSearchChange(searchValue : string) {
        if (!this.searchChangeObservable) {
            Observable.create(observer => {
                this.searchChangeObservable = observer;
            }).debounceTime(300) // wait 300ms after the last event before emitting last event
              .distinctUntilChanged() // only emit if value is different from previous value
              .subscribe(() => { this.searchForAccount() });
        }

		this.searchChangeObservable.next(searchValue);
    }

	private async searchForAccount() {
        this.loadingData = true;
        const results = await this.dataService.getStaffUserSearch(this.judgeForm.value.search.firstName, this.judgeForm.value.search.lastName);
        this.userResults = results.filter(x => !!x.emailAddress); //only show accounts with an email
        console.log('results', this.userResults);
        this.loadingData = false;
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/settings/judge-popup.ts